import { AcceptTosMutation, AcceptTosMutationVariables } from "@/Apollo/schema";
import { MutationHookOptions, useMutation } from "@apollo/client";
import mutationGQL from "@/Apollo/mutation/acceptTOS.graphql";

export const useAcceptTOS = (
  options?: MutationHookOptions<AcceptTosMutation, AcceptTosMutationVariables>
) => {
  return useMutation(mutationGQL, options);
};
